import React from 'react';
import AvlagaUglugTovchoo from './avlagaUglug';

const PageList = () => <AvlagaUglugTovchoo />;

export default PageList;
